<template>
  <el-dialog
    title="新增商品"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="product"
      label-width="100px">
      <el-form-item
        label="企业名称："
        prop="vendorName">
        {{ product.vendorName }}
      </el-form-item>
      <el-form-item
        v-for="(item, index) in product.productNames"
        :key="item.key"
        label="商品名称："
        :prop="'productNames.' + index + '.value'"
        :rules="{
          required: true, message: '请输入商品名称', trigger: 'blur'
        }">
        <el-input
          v-model="item.value"
          style="width:240px"></el-input>
        <el-button
          v-if="productLen > 1"
          type="danger"
          style="margin-left: 10px"
          :loading="loading"
          @click="deleteitem(index)">
          删除
        </el-button>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="additem">
        增加商品
      </el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'AddModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      product: {
        vendorId: null,
        vendorName: null,
        productNames: [
          {
            value: '',
            key: Date.now()
          }
        ]
      }
    }
  },
  computed: {
    productLen() {
      return this.product.productNames.length
    }
  },
  methods: {
    additem() {
      this.product.productNames.push({
        value: '',
        key: Date.now()
      })
    },
    deleteitem(index) {
      this.product.productNames.splice(index, 1)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$set(this, 'product', {
        vendorId: null,
        vendorName: null,
        productNames: [
          {
            value: '',
            key: Date.now()
          }
        ]
      })
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { vendorId, productNames } = this.product
          this.$store.dispatch(`account/addproducts`, {
            payload: productNames.map(i => ({
              vendorId,
              productName: i.value
            }))
          })
            .then((res) => {
              console.log(res)
              // this.$message.success('新增商品成功')
              // this.toggleModal(false)
              // this.loading = false
            })
            .catch(() => {
              // this.toggleModal(false)
              // this.loading = false
            })
            .finally(() => {
              // this.$message.success('新增商品成功')
              this.toggleModal(false)
              this.loading = false
              this.callback && this.callback()
            })
        }
      })
    },
    init(options = {}) {
      this.product = {
        ...this.product,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
